import type { DataStrategyFunction } from 'react-router-dom';
import { prepareStencilRouteTransition } from './stencil-route-transition.controller';

export const stencilNavigationDataStrategy: DataStrategyFunction = async ({ fetcherKey, matches }) => {
    if (fetcherKey === null) {
        await prepareStencilRouteTransition();
    }

    const results = await Promise.all(matches.map(async (match) => [match.route.id, await match.resolve()] as const));

    return Object.fromEntries(results);
};
